"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _get = _interopRequireDefault(require("transmute/get"));

var Title = function Title(_ref) {
  var apiData = _ref.apiData;
  return (0, _get.default)('label', apiData);
};

Title.propTypes = {
  apiData: _propTypes.default.shape({
    label: _propTypes.default.string.isRequired
  }).isRequired
};
var _default = Title;
exports.default = _default;
module.exports = exports.default;